<template>
    <div class="mx-auto">
        <p class="mb-2"><b>Informe o Devedor:</b>
            <i class="fas fa-info-circle text-info fa-12x ml-3" variant="info"
               v-b-modal.modal-info-devedor></i>
        </p>

        <b-row v-if="devedores == null">
            <b-col md="2">
                <b-form-group
                        label="Número do CPF / CNPJ:"
                        label-for="cpf"
                        class="text-label"
                        :description="validations.cpf.valid ? 'Somente os números' : ''">
                    <b-form-input
                            type="text"
                            id="num-documento"
                            data-vv-as="CPF"
                            v-model="trp.devedor.documento"
                            v-mask="['XX.XXX.XXX', 'XXX.XXX.XXX-XX', 'XX.XXX.XXX/XXXX-##']"
                            @change="buscarDevedor();"
                            :class="'cpfCnpj ' + (!validations.cpf.valid ? 'is-invalid' : '')"
                    ></b-form-input>
                    <span v-if="!validations.cpf.valid && validations.cpf.invalidDocument" class="invalid-message">Documento inválido!</span>
                    <span v-if="!validations.cpf.valid && validations.cpf.semCarta" class="invalid-message">Não consta(m) dívida(s) ativa(s) ajuizada(s) inscritas pela SEFA para o Devedor informado registrada(s) no PROAJU!</span>
                </b-form-group>
            </b-col>
            <b-col md="6">
                <b-form-group
                        label="Nome / Razão Social do Devedor:"
                        label-for="devedor"
                        class="text-label">
                    <b-form-input
                            v-if="trp.devedor.codContribuinte != null"
                            type="text"
                            id="devedor"
                            v-model="trp.devedor.nome"
                            :disabled="true"
                            data-vv-as="devedor"
                            description="Devedor"
                    ></b-form-input>
                    <b-form-input
                            v-if="trp.devedor.codContribuinte == null"
                            type="text"
                            id="devedor"
                            :disabled="true"
                            data-vv-as="devedor"
                            description="Devedor"
                    ></b-form-input>
                </b-form-group>
            </b-col>
            <b-col md="2" class="mt-4" style="margin-left: -15px;">
                <b-button
                        tabindex="-1"
                        class="icon-button"
                        title="Abrir Cadastro do Devedor"
                        variant="outline-primary"
                        :disabled="!validations.cpf.valid || (trp.devedor.documento == null || trp.devedor.documento == '')"
                        @click="abrirModalDevedor(trp.devedor, false)">
                    <i class="far fa-address-book fa-flip-horizontal vertical-middle"></i>
                </b-button>
	            <b-button
		            tabindex="-1"
		            class="icon-button btn-documentos"
		            title="Documentação do Devedor"
		            variant="outline-primary"
		            :disabled="!validations.cpf.valid || (trp.devedor.documento == null || trp.devedor.documento == '')"
		            @click="abrirModalDocumentosDevedor()">
		            <i class="far fa-copy fa-flip-horizontal vertical-middle"></i>
	            </b-button>
            </b-col>
        </b-row>

        <hr>

        <b-row>
            <b-col md="4">
                <p class="mb-2"><b>Tipo de TRP a ser emitido:</b>
                    <i class="fas fa-info-circle text-info fa-12x ml-3" variant="info"
                       tabindex="-1"
                       v-b-modal.modal-info-trp></i>
                </p>
                <b-form-group label>
                    <b-form-select v-model="trp.tipoTrp" :disabled="!validations.cpf.valid || trp.devedor.codContribuinte == null"
                            class="tipoTrp">
                        <template v-slot:first>
                            <option :value="null">Selecionar</option>
                        </template>
                        <option
                                v-for="tc in dados.listaTipoTrp"
                                :key="tc.codTipoTrp"
                                :value="tc">
                            {{ tc.descricao }}
                        </option>
                    </b-form-select>
                </b-form-group>
            </b-col>
            <b-col md="8">
                <p class="mb-2"><b>Condições do TRP selecionado:</b></p>
                <ul class="condicoes">
                    <li v-if="trp.tipoTrp && trp.tipoTrp.indExigeRequisicao">{{trp.tipoTrp.descricaoExigeRequisicao}}</li>
                    <li v-if="trp.tipoTrp && trp.tipoTrp.indExigeDesistencia">{{trp.tipoTrp.descricaoExigeDesistencia}}</li>
                    <li v-if="trp.tipoTrp && trp.tipoTrp.indExigePagamentoCustas">{{trp.tipoTrp.descricaoExigePagamentoCustas}}</li>
                    <li v-if="trp.tipoTrp && trp.tipoTrp.indExigeGarantia">{{trp.tipoTrp.descricaoExigeGarantia}}</li>
                </ul>
            </b-col>
        </b-row>

        <b-modal
                ref="modal-info-devedor"
                id="modal-info-devedor"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title="Informe o CPF/CNPJ do Devedor"
                header-bg-variant="info"
                header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <ul>
                        <li>
                            <p>Informe o CPF/CNPJ do devedor para visualizar o seu dossiê de dívidas ativas ajuizadas, registradas na base do sistema PROAJU, e pendentes no FIR para o tipo de TRP a ser selecionada abaixo.</p>
                        </li>
                    </ul>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="primary" @click="hide('modal-info-devedor')"> Fechar</b-button>
            </template>
        </b-modal>
        <b-modal
                ref="modal-info-trp"
                id="modal-info-trp"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title="Selecione o tipo de TRP a ser emitido"
                header-bg-variant="info"
                header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <ul>
                        <li>
                            <p>Selecione um dos tipos de TRP a ser emitido de acordo com a opção de pagamento ou parcelamento do débito principal manifestada pelo devedor.</p>
                        </li>
                    </ul>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="primary" @click="hide('modal-info-trp')"> Fechar</b-button>
            </template>
        </b-modal>

        <CompLoading ref="loadingDevedor"/>
        <ModalIncluirDevedor ref="modalDevedor"
                             @novoDevedor="salvarDevedor"
                             @cancelarNovoDevedor="mudarFocusCpf" />
        <ModalAlterarDevedor
                ref="modalAlterarDevedor"
                :loading="$refs.loadingDevedor"
                @salvarDevedor="salvarDevedor"/>

	    <ModalDocumentosDevedor ref="modalDocumentosDevedor"
	                            :loading="$refs.loadingDevedor"/>
    </div>
</template>

<script>
    import axios from 'axios';
    import formatarMixins from '../../../mixins/formatarMixins';
    import ModalIncluirDevedor from "../../shared/components/ModalIncluirDevedor";
    import ModalAlterarDevedor from "../../shared/components/ModalAlterarDevedor";
    import CompLoading from "../../shared/components/CompLoading";
    import ModalDocumentosDevedor from "../../shared/components/ModalDocumentosDevedor";

    export default {
        props: ['trp'],
        mixins: [ formatarMixins ],
        components: {ModalDocumentosDevedor, ModalIncluirDevedor, ModalAlterarDevedor, CompLoading},
        data() {
            return {
                urlApi: null,
                devedores: null,
                devedorAtual: null,
                radioDevedor: null,
                validations: {
                    cpf: {
                        valid: true,
                        invalidDocument: false,
                        semCarta: false
                    }
                },
                dados: {
                    listaTipoTrp: []
                }
            }
        },
        computed: {
            getTheme () {
                return this.$store.getters.getTheme
            }
        },
        methods: {
            async listarTipoTrp() {
                axios.get(`${this.urlApi}/v1/trp/listarTipoTrp`, {
                    headers: {
                        'Authorization': this.token
                    }
                }).then(response => {
                    this.dados.listaTipoTrp = response.data;
                })
            },
            async buscarDevedor() {
                this.validations.cpf.valid = true;
                this.validations.cpf.invalidDocument = false;
                this.validations.cpf.semCarta = false;
                if(this.trp.devedor.documento == null || this.trp.devedor.documento == "") {
                    this.atribuirDevedor(null);
                    return;
                }

                if(this.trp.devedor.documento.length < 10 || (this.trp.devedor.documento.length > 10 && this.trp.devedor.documento.length <= 14 && !this.validarCpf(this.trp.devedor.documento))
                    || (this.trp.devedor.documento.length > 14 && !this.validarCnpjAlfanumerico(this.trp.devedor.documento))) {
                    this.validations.cpf.valid = false;
                    this.validations.cpf.invalidDocument = true;
                    this.trp.devedor.nome = "";
                    this.mudarFocusCpf();
                    return;
                }

                let devedor = {
                    documento: this.trp.devedor.documento
                };

                this.$refs.loadingDevedor.showLoading();
                    axios.post(`${this.urlApi}/v1/trp/obterContribuinte`, devedor, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    if(response.data != null && response.data != "") {
                        let devedorRetorno = response.data;
                        devedorRetorno.documento = this.trp.devedor.documento;
                        this.atribuirDevedor(devedorRetorno);

                        setTimeout(()=>{
                            if(this.trp.devedor.codContribuinte == null) {
                                this.$refs.modalDevedor.abrirModalIncluirDevedorComDados(this.trp.devedor);
                            } else {
                                this.mudarFocusTipoTrp();
                            }
                        }, 200);
                    } else {
                        this.trp.devedor.nome = null;
                        this.validations.cpf.valid = false;
                        this.validations.cpf.semCarta = true;
                    }
                }).finally(() => {
                    this.$refs.loadingDevedor.hideLoading();
                })
            },
            abrirModalDevedor(devedor, devedorLista) {
                if(devedorLista) {
                    this.devedorAtual = devedor;
                } else {
                    this.devedorAtual = null;
                }

                if(devedor.codContribuinte != null) {
                    this.$refs.modalAlterarDevedor.carregarCadastro(devedor.codContribuinte);
                } else {
                    this.$refs.modalDevedor.abrirModalIncluirDevedorComDados(devedor);
                }
            },
            salvarDevedor(contribuinte) {
                if(this.devedorAtual != null) {
                    let listaDevedores = [];
                    for(let i = 0; i < this.devedores.length; i++) {
                        if(this.devedores[i].documento == contribuinte.documento) {
                            listaDevedores.push(contribuinte);
                        } else {
                            listaDevedores.push(this.devedores[i]);
                        }
                    }
                    this.devedores = listaDevedores;
                }
                this.atribuirDevedor(contribuinte);
            },
            atribuirDevedor(contribuinte) {
                this.$emit('atribuirDevedor', contribuinte);

                if(contribuinte != null && contribuinte.codContribuinte == null) {
                    setTimeout(()=>{
                        if(this.trp.devedor.codContribuinte == null) {
                            this.$refs.modalDevedor.abrirModalIncluirDevedorComDados(this.trp.devedor);
                        }
                    }, 200);
                }
            },
            validarForm() {
                return this.validations.cpf.valid
                    && this.trp.devedor.codContribuinte != null
                    && this.trp.tipoTrp != null
                    && !this.$refs.modalDevedor.isShow()
                    && !this.$refs.modalAlterarDevedor.isShow();
            },
            mudarFocusCpf() {
                document.getElementsByClassName('cpfCnpj')[0].focus();
            },
            mudarFocusTipoTrp() {
                document.getElementsByClassName('tipoTrp')[0].focus();
            },
            modalOpen() {
                return this.$refs.modalDevedor.isShow() || this.$refs.modalAlterarDevedor.isShow();
            },
	        abrirModalDocumentosDevedor () {
		        document.activeElement.blur();
		        this.$refs['modalDocumentosDevedor'].abrirModal(this.trp.devedor.documento, this.trp.devedor.codContribuinte);
	        },
        },
        mounted() {
            this.urlApi = process.env.VUE_APP_ROOT_API;
            this.token = JSON.parse(this.$store.getters.getUser).access_token;
            this.listarTipoTrp();
        }
    }
</script>

<style scoped>
    .icon-button {
        font-size: 1.5rem;
        margin-left: 1rem;
        padding: 0 0.5rem;
    }

    .vertical-middle {
        vertical-align: middle;
    }
</style>
